export interface User {
    id: number;
    email: string;
    name: string;
    role: 'ADMIN' | 'USER';
    is_active: boolean;
    created_at: string;
    updated_at: string;
    is_2fa_enabled: boolean;
}

export const ROLE_LABELS: Record<User['role'], string> = {
    ADMIN: 'Amministratore',
    USER: 'Utente',
};
